import React from 'react';
import { Card, CardContent } from '@/components/ui';

export interface DocumentItem {
  id: string;
  name: string;
  type: 'pdf' | 'dwg' | 'xlsx';
  date: string;
}

interface RecentDocumentsProps {
  items?: DocumentItem[];
  isLoading?: boolean;
}

export function RecentDocuments({ items, isLoading }: RecentDocumentsProps) {
  const defaultItems: DocumentItem[] = [
    { id: '1', name: 'Biện pháp thi công cảnh quan Khu A.pdf', type: 'pdf', date: '15/05/2024' },
    { id: '2', name: 'Bản vẽ hệ thống tưới tự động.dwg', type: 'dwg', date: '15/05/2024' },
    { id: '3', name: 'Tiến độ tổng thể dự án.xlsx', type: 'xlsx', date: '14/05/2024' },
  ];

  const displayItems = items || defaultItems;

  const getIcon = (type: string) => {
    switch (type) {
      case 'pdf': return <i className="ri-file-pdf-fill text-red-500 text-lg" />;
      case 'dwg': return <i className="ri-file-code-fill text-blue-500 text-lg" />;
      case 'xlsx': return <i className="ri-file-excel-fill text-emerald-600 text-lg" />;
      default: return <i className="ri-file-text-line text-slate-400 text-lg" />;
    }
  };

  return (
    <Card className="border-none shadow-sm h-full flex flex-col">
      <CardContent className="p-6 flex-1 flex flex-col">
        <h3 className="text-sm font-bold text-slate-800 mb-6">Tài liệu - Bản vẽ mới cập nhật</h3>

        <div className="flex-1 space-y-4">
          {displayItems.map((item) => (
            <div key={item.id} className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                {getIcon(item.type)}
                <span className="text-xs font-medium text-slate-600 truncate max-w-[180px] leading-tight">{item.name}</span>
              </div>
              <span className="text-[10px] font-bold text-slate-400 whitespace-nowrap">{item.date}</span>
            </div>
          ))}
        </div>

        <div className="mt-6 pt-4 border-t border-slate-50">
          <button className="text-[10px] font-bold text-emerald-600 flex items-center gap-2 hover:underline">
            Xem tất cả tài liệu
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </CardContent>
    </Card>
  );
}
